import React, { ReactNode } from 'react';
import { Theme } from '../../styles/themes';

export interface ThemeContainerProps {
  selectedTheme?: Theme;
  children?: ReactNode;
}

export const ThemeContext = React.createContext(Theme.Default);

const ThemeContainer = React.forwardRef<
  HTMLDivElement,
  ThemeContainerProps & React.HTMLAttributes<HTMLDivElement>
>(({ selectedTheme, children, ...rest }, ref) => {
  return (
    <ThemeContext.Provider value={selectedTheme || Theme.Default}>
      <div ref={ref} data-theme={selectedTheme || Theme.Default} {...rest}>
        {children}
      </div>
    </ThemeContext.Provider>
  );
});

ThemeContainer.displayName = 'ThemeContainer';

export default ThemeContainer;
